import React from 'react';
import { Modal } from 'react-bootstrap';

const KdsModal = ({show,handleClose,itemData}) => {

  //video
  const isVideo = (url) => {
    const videoExtensions = ["mp4", "webm", "ogg"];
    const extension = url.split('.').pop().toLowerCase();
    return videoExtensions.includes(extension);
  };
  //check image
  const isImage = (url) => {
    const imageExtensions = ["png", "jpg", "jpeg", "gif", "webp"];
    const extension = url.split('.').pop().toLowerCase();
    return imageExtensions.includes(extension);
  };

  return (
    <>
      <Modal show={show} onHide={handleClose} centered size="md">
        <Modal.Header closeButton>
          <Modal.Title className='m-0'><h6 className='m-0'>{itemData.token}</h6></Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {itemData?.name && <h6>{itemData.name}</h6>}
          {/* Full-size image */}
          <div className='text-center'>
            {
              isImage(itemData.url) ? (
                <img
                  src={itemData.url}
                  alt="Full-size"
                  className="img-thumbnail bill_modal_scroll"
                />
              ) :  (
                isVideo(itemData.url) ? (
                  <video 
                    autoPlay 
                    className="img-thumbnail bill_modal_scroll"
                  >
                    <source src={itemData.url} type="video/mp4"/>
                  </video>
                ) : (
                  <iframe
                    src={itemData.url }
                    title="viewer"
                    width="100%"
                    height="450px"
                    className='bill_modal_scroll'
                    frameborder="0"
                    style={{ border: "none" }}
                  />
                )
              )
            }
          </div>
        </Modal.Body>
      </Modal>
    </>
  )
}

export default KdsModal
